export default [
  {
    path: '/system/settings',
    name: 'settings',
    component: () => import('@/views/system/settings/Settings.vue'),
  },
]
